// extracted by mini-css-extract-plugin
module.exports = {"core-context":"context_core-context__8lKDB"};